import { useContext, useEffect, useState } from "react";
import { AuthContext } from "../../context/auth";
import { getProjectStatus } from "../../services/organization-user/organization.service";
import PausedBannerView from "./index.view";

const BANNER_ELIGIBLE_ROLES = new Set([
    "Admin",
    "Organization Admin",
    "Manager",
    "Budtender",
]);

const PausedBanner: React.FC = () => {
    const { authState } = useContext(AuthContext);
    const [projectStatus, setProjectStatus] = useState<string | null>(null);

    const userType = authState?.user?.attributes?.type;
    const roleName =
        authState?.user?.relationships?.role?.attributes?.name ?? "";
    const isClientPortalUser =
        userType === "user" && BANNER_ELIGIBLE_ROLES.has(roleName);

    // Fetch the project status once for eligible client users. The paused state
    // is sticky server-side, so a single fetch on mount is sufficient — no poll.
    // Uses getProjectStatus (raw axios) rather than the httpClient-backed
    // getTenantProject: the /overview dashboard also GETs the project endpoint
    // on mount, and httpClient aborts the earlier of two same-URL requests into
    // a never-resolving promise — which previously left this banner blank on
    // /overview until another page was loaded first.
    useEffect(() => {
        if (!authState?.loading && isClientPortalUser) {
            getProjectStatus().then(setProjectStatus);
        }
    }, [authState?.loading, isClientPortalUser]);

    const visible = isClientPortalUser && projectStatus === "paused";

    return <PausedBannerView visible={visible} />;
};

export default PausedBanner;
